import Button from "@covertree/ui/buttons/Button";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

interface Props {
  title: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  description: JSX.Element;
  buttonLabel: string;
  action: () => void;
}

export const SuccessScreen = ({
  title,
  maxWidth = "xs",
  description,
  buttonLabel,
  action,
}: Props) => {
  return (
    <Container maxWidth={maxWidth}>
      <Grid container direction="column" justifyContent="center" spacing={3}>
        <Grid item>
          <Box ml={-3.5}>
            <img
              src="/images/icons/checkmark.webp"
              alt="success"
              height={184}
              width={184}
              data-testid="check-icon"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid item>
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
        {description}
      </Grid>
      <Grid item>
        <Button fullWidth onClick={action}>
          {buttonLabel}
        </Button>
      </Grid>
    </Container>
  );
};

export default SuccessScreen;
